// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qualify-modal-sdk-iframeModal-41d50 .ant-modal-close{color:#495366;right:16px;top:20px}.qualify-modal-sdk-iframeModal-41d50 .ant-modal-close .ant-modal-close-x{height:16px;width:32px}.qualify-modal-sdk-iframeModal-41d50 .ant-modal-close:hover{background-color:transparent}.qualify-modal-sdk-iframeModal-41d50 .ant-modal-close:hover svg path{transition:stroke .2s ease;stroke:rgba(73,83,102,.4)}.qualify-modal-sdk-iframeContent-198df{border:none;border-radius:0;display:block;transform:translateZ(0)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframeModal": `qualify-modal-sdk-iframeModal-41d50`,
	"iframeContent": `qualify-modal-sdk-iframeContent-198df`
};
export default ___CSS_LOADER_EXPORT___;
